module.exports = __webpack_public_path__ + "img/pat-panda.8fe9b5d8.png";